<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { mapGetters, mapActions } from 'vuex'
import vSelect from 'vue-select'
import store from '@/store'
import router from '@/router'

import { Watch } from 'vue-property-decorator'

import EventBus from '@/event-bus'


Vue.component('v-select', vSelect)

@Component({
    props: {
        schools: Array,
        userRole: String
    }
})

export default class SchoolsDropdown extends Vue {

    selectedSchool = null

    @Watch('selectedSchool')
        onChildChanged(val) {
            this.fetchSelectedSchool(val)
            if (router.currentRoute.name === 'home') {
               EventBus.$emit('school selected') 
            }
        }

    mounted () {
        const school = store.getters['admin/getSelectedSchool']
        if (school.dbn) {
            this.selectedSchool = school
        }
    }

    fetchSelectedSchool(value) {
        this.$store.dispatch('admin/fetchSelectedSchool', value)

        this.role = this.userRole
        
        this.$ga.event({
            eventCategory: 'Select School From Dropdown',
            eventAction: value.school_dbn,
            eventLabel: this.role
        })
    }
}

</script>

<template>
    <v-select 
        label="LocationName"
        v-model="selectedSchool"
        :options="schools"
        :value="selectedSchool"
        placeholder="Select a School">
    </v-select>
</template>

<style lang="sass" scoped>

</style>
